import { useMutation } from '@apollo/client';
import { DynamicPricingInput } from '../types';
import { SUBMIT_INSURANCE_QUOTE } from '../api/submitInsuranceQuote';
import { useState } from 'react';
import { useTrackingEvents } from '../../../../hooks/useTrackingEvents';
import { Account, CreditApplication, TrackingEventEnum, TrackingEventsPublicType } from '@trnsact/trnsact-shared-types';
import { newRelicNoticeError, newRelicAddPageAction } from '../../../../tracking/newrelic';


export const useInsuranceQuoteSubmit = (refetchTask: any) => {

  const [submitInsuranceQuote] = useMutation(SUBMIT_INSURANCE_QUOTE);

  const { createTrackingEvent } = useTrackingEvents();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isErrorOnSubmit, setIsErrorOnSubmit] = useState<boolean>(false);

  const submit = async (
    taskId: string,
    insuranceQuoteId: string,
    dynamicPricingInput: DynamicPricingInput,
    creditApplication: CreditApplication,
    publicAccount: Account
  ) => {
    try {
      setIsLoading(true);
      setIsErrorOnSubmit(false);
      newRelicAddPageAction('InsuranceQuote:submitStarted');
      const result = await submitInsuranceQuote({
        variables: {
          input: {
            insuranceQuoteId,
            taskId,
            inputValue: dynamicPricingInput,
          },
        },
      });
      const proposalId = result?.data?.insuranceQuote?.submitInsuranceQuote?.proposalId ?? null;
      if (proposalId) {
        await refetchTask();
        await createTrackingEvent({
          variables: {
            input: {
              eventType: TrackingEventsPublicType.InsuranceExpress,
              event: TrackingEventEnum.InsuranceQuoteProposalGenerated,
              eventData: { creditApplicationId: creditApplication.id, taskId },
              accountId: publicAccount.id,
            },
          },
        });
      } else {
        setIsErrorOnSubmit(true);
        await createTrackingEvent({
          variables: {
            input: {
              eventType: TrackingEventsPublicType.InsuranceExpress,
              event: TrackingEventEnum.InsuranceQuoteProposalGenerationFailed,
              eventData: { creditApplicationId: creditApplication.id, taskId },
              accountId: publicAccount.id,
            },
          },
        });
      }
      return proposalId;
    } catch (error) {
      console.error(error);
      newRelicNoticeError(error as Error, { action: 'insuranceQuote:submit' });
      setIsErrorOnSubmit(true);
      return null;
    }
    finally {
      setIsLoading(false);
    }
  };

  return {
    submit,
    isErrorOnSubmit,
    isSubmitLoading: isLoading,
  };
};
